/* eslint-disable */
// @ts-nocheck
import { ghb } from "@cervval.js/i18n/src/i18n.tools";

export const i18n = {
    buttonLabel: {
        excelLikeClearSort: "Clear sort",
        excelLikeColumnConfigurator: "Columns Configuration",
        excelLikeExport: "Export",
        excelLikeFiltersCancelButton: "Cancel",
        excelLikeFiltersOkButton: "Ok",
        excelLikeSortAsc: "Sort ascending",
        excelLikeSortDesc: "Sort descending"
    },
    filterEmptyNullUndefinedValue: "(Blanks)"
};